import { trackBuyflowEvent } from "src/utils/api/tracker";

export const onCompleteLandingPageSurvey = (): void => {
  trackBuyflowEvent("BuyflowSurveyFinished", {
    surveyName: "LandingPageSurvey",
  });
};
